import PageTitle from '../../components/CommonComps/Titles/PageTitle';
import ShowAllPurchaseHistory from '../../components/HistoryComps/PurchaseComps/ShowAllPurchaseHistory';

const Purchase = () => {
  // rendering purchase history page component here
  return (
    <>
      <PageTitle title='Purchase History' />

      <ShowAllPurchaseHistory />
    </>
  );
};

export default Purchase;
